import { PROFILE_KEY } from './key'
import { MODEL_KEYS } from '../../../modules/model/constants'
import { omitByObjectUtil } from 'packages/src'

export * from './bmi.js'
export * from './coach-intensity-level'
export * from './fitness-data-keys.js'
export * from './body-type.js'
export * from './goal.js'
export * from './goal-obstacle'
export * from './interestFocus'
export * from './injury'
export * from './workoutDurationGoal'
export * from './desired-outcome'
export * from './diet-type'
export * from './gender.js'
export * from './role.js'
export * from './key.js'
export * from './training-frequency.js'

export const PROFILE_ASSOCIATIONS = [
  PROFILE_KEY.WORKOUTS,
  PROFILE_KEY.PLANS,
  PROFILE_KEY.TAGS,
  PROFILE_KEY.PREFERENCES,
  PROFILE_KEY.FEEDBACK,
  PROFILE_KEY.MEDIA,
  PROFILE_KEY.FEEDBACK_REPLIES,
  PROFILE_KEY.EXERCISE_LOGS,
  PROFILE_KEY.EXERCISE_LOG_SUMMARIES
]

export const PROFILE_KEYS = Object.values(PROFILE_KEY)

export const PUBLIC_ATTRIBUTES = [
  ...MODEL_KEYS,
  PROFILE_KEY.ROLE,
  PROFILE_KEY.NAME
]

export const PROFILE_ATTRIBUTES_FOR_MESSAGE = PUBLIC_ATTRIBUTES
export const PROFILE_DEFAULT_WEIGHT_IN_KG = 70

export const PROFILE_FITNESS_DATA_KEYS = [
  PROFILE_KEY.GOAL,
  PROFILE_KEY.GOAL_OBSTACLE,
  PROFILE_KEY.INTEREST_FOCUS,
  PROFILE_KEY.DIET_TYPE,
  PROFILE_KEY.DESIRED_OUTCOME,
  PROFILE_KEY.FITNESS_LEVEL,
  PROFILE_KEY.TRAINING_FREQUENCY,
  PROFILE_KEY.WEEKLY_WORKOUTS_COUNT_GOAL,
  PROFILE_KEY.WORKOUT_DURATION_GOAL,
  PROFILE_KEY.GENDER,
  PROFILE_KEY.BIRTHDAY,
  PROFILE_KEY.WEIGHT,
  PROFILE_KEY.HEIGHT,
  PROFILE_KEY.BODY_TYPE,
  PROFILE_KEY.INJURIES
]

export const PROFILE_NUTRITION_KEYS = [
  PROFILE_KEY.DAILY_CALORIE_INTAKE_GOAL
]

export const PROFILE_FITNESS_AND_NUTRITION_KEYS = [
  ...PROFILE_FITNESS_DATA_KEYS,
  ...PROFILE_NUTRITION_KEYS
]

export const PROFILE_COACHING_KEYS = [
  PROFILE_KEY.COACH_INTENSITY_LEVEL
]

export const PROFILE_ONBOARDING_KEYS = [
  ...PROFILE_FITNESS_DATA_KEYS,
  ...PROFILE_NUTRITION_KEYS,
  PROFILE_KEY.GYM_ACCESS,
  ...PROFILE_COACHING_KEYS
]

export const PROFILE_ATTRIBUTES_FOR_CREATOR = [
  ...PUBLIC_ATTRIBUTES,
  ...PROFILE_FITNESS_DATA_KEYS,
  PROFILE_KEY.COUNTRY,
  PROFILE_KEY.EMAIL,
  PROFILE_KEY.USER_ID,
  PROFILE_KEY.PLATFORM,
  PROFILE_KEY.FIRST_NAME,
  PROFILE_KEY.LAST_NAME,
  PROFILE_KEY.APP_VERSION,
  PROFILE_KEY.GENDER,
  PROFILE_KEY.HEIGHT_UNIT,
  PROFILE_KEY.WEIGHT_UNIT,
  PROFILE_KEY.BMR,
  PROFILE_KEY.BMI,
  PROFILE_KEY.BMI_CATEGORY,
  PROFILE_KEY.TOTAL_ENERGY_EXPENDITURE,
  PROFILE_KEY.AVERAGE_TRAINING_VOLUME,
  PROFILE_KEY.AVERAGE_CALORIES_BURNED,
  PROFILE_KEY.AVERAGE_TRAINING_TIME,
  PROFILE_KEY.MAX_TRAINING_TIME,
  PROFILE_KEY.MAX_CONSECUTIVE_WORKOUTS_COUNT,
  PROFILE_KEY.MAX_CALORIES_BURNED,
  PROFILE_KEY.LAST_WORKOUT_LOGGED_AT
]

export const profilePrivateObj = omitByObjectUtil(PROFILE_KEY, (val) => {
  return PUBLIC_ATTRIBUTES.includes(val)
})

export const PROFILE_PRIVATE_KEYS = [
  ...Object.values(profilePrivateObj)
]

export const PROFILE_AUDIT = {
  AUTHENTICATED: 'Profile Authenticated',
  ONE_TIME_USAGE_JWT_CREATED: 'Profile One Time Usage JWT Created',
  LOGGED_IN: 'Profile Logged In',
  LOGGED_IN_WITH_FACEBOOK: 'Profile Logged In With Facebook',
  LOGGED_IN_WITH_APPLE: 'Profile Logged In With Apple',
  LOGGED_OUT: 'Profile Logged Out',
  EXISTS: 'Profile Exists',
  SIGNED_UP: 'Profile Signed Up',
  CREATED: 'Profile Created',
  DELETED: 'Profile Deleted',
  UPDATED: 'Profile Updated'
}

export const PROFILE_CLASS_NAME = 'Profile'

export const PROFILE_BMI_CATEGORY = {
  UNDERWEIGHT: 1,
  NORMAL: 2,
  OVERWEIGHT: 3,
  OBESE_1: 4,
  OBESE_2: 5,
  OBESE_3: 6
}

export const PROFILE_GENDER = {
  MALE: 1,
  FEMALE: 2,
  OTHER: 3
}

export const PROFILE_ROLE = {
  ADMIN: 1,
  COACH: 2,
  CREATOR: 3
}

export const PROFILE_SCOPE = {
  /**
   * Only returns the public attributes of a `Settings`.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: PROFILE_PRIVATE_KEYS
    }
  }
}
